<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path fill="currentColor" d="M19.955 10.586L21.369 12l-3.977 3.978 3.977 3.977-1.414 1.414-3.977-3.977L12 21.369l-1.414-1.414 3.978-3.977L10.586 12 12 10.586l3.978 3.978 3.977-3.978z"/>
</svg>
